import { getModuleGroupById, registerApplication } from '@softline/application';
import { default as de } from '../i18n/de.json';
import {
  SOFTLINE_CONFIG_WORKFLOW_TYPE,
  WorkflowTypeConfig,
} from '@softapps/gewerbe/workflow';
import { StockPostingRepository } from './repository/stock-posting.repository';
import { StockPostingResourceService } from './services/stock-posting-resource.service';

export const einseitigeLagerbuchungProviders = [
  registerApplication({
    name: 'Lagerbuchung',
    icon: 'fa-regular fa-boxes-packing',
    title: 'Einseitige Lagerbuchung',
    route: '/mde-stockposting/erfassung',
    permission: 'SOFTAPPS.MDE.STOCKPOSTING.ACCESS',
    group: getModuleGroupById(6),
    translations: {
      de,
    },
  }),
  {
    provide: SOFTLINE_CONFIG_WORKFLOW_TYPE,
    useValue: {
      type: 'STOCKPOSTING',
      getRoute: (workflow) => ['/mde-stockposting/workflow', String(workflow.id)],
      getDetailComponent: () =>
        import('./pages/stock-posting-workflow/stock-posting-workflow').then(
          (m) => m.default
        ),
      getDetailInputs: (workflow) => ({ workflowIdInput: workflow.id, embedded: true }),
      getDetailProviders: () => [StockPostingRepository, StockPostingResourceService],
      viewModes: ['table', 'kanban'],
    } satisfies WorkflowTypeConfig,
    multi: true,
  },
];
